import type { AsyncStatus } from "@react-hookz/web";
import type { Dispatch, SetStateAction } from "react";
import { useEffect } from "react";

import { useOnDemandInsightsLoader } from "../../../../hooks/onDemandInsights/useOnDemandInsightsLoader";
import { isSuccess } from "../../../../utils/api.utils";
import { withInsightsRenderer } from "../withInsightsRenderer";

import { OnDemandInsightCard } from "./OnDemandInsightsCard";

interface OnDemandInsightsProps {
    isLoaderInView: boolean;
    setAsyncStatus: Dispatch<SetStateAction<AsyncStatus>>;
    setTotalCount: Dispatch<SetStateAction<number>>;
}

export const OnDemandInsights: React.FunctionComponent<
    OnDemandInsightsProps
> = (props: OnDemandInsightsProps) => {
    const { isLoaderInView, setAsyncStatus, setTotalCount } = props;
    const [asyncStatus, lazyLoadedInsights, totalResults] =
        useOnDemandInsightsLoader({
            isLoaderInView,
        });

    useEffect(() => {
        setAsyncStatus(asyncStatus);
    }, [asyncStatus]);

    useEffect(() => {
        if (isSuccess(asyncStatus)) {
            setTotalCount(totalResults);
        }
    }, [asyncStatus, totalResults]);

    return (
        <>
            {lazyLoadedInsights.map((template, index) => (
                <OnDemandInsightCard
                    template={template}
                    key={index}
                    index={index}
                />
            ))}
            {asyncStatus === "error" && <div>Failed to load contents</div>}
        </>
    );
};

export const OnDemandInsightsViewer = withInsightsRenderer(OnDemandInsights);
